import { getActiveEnvProfile } from "@/utils/utils";
import { Layout } from "antd";
import classNames from "classnames";
import { useCurrentAccount } from "../../../modules/auth/hooks";
import { isAgentUserAccount } from "../../../modules/user/utils";
import { GlobalSearch } from "../globalsearch/GlobalSearch";
import { NotificationView } from "../notification/NotificationView";
import { UserMenuView } from "../usermenu/UserMenuView";
import styles from "./Header.module.scss";

type Props = {
  isMenuCollapsed?: boolean;
};

export const Header = ({ isMenuCollapsed }: Props) => {
  const userAccount = useCurrentAccount();

  const isAgentAccount = isAgentUserAccount(userAccount);

  const activeEnvProfile = getActiveEnvProfile();

  return (
    <Layout.Header
      className={classNames(styles.headerWrapper, {
        [styles.headerWithSideMenu as string]: isAgentAccount && !isMenuCollapsed,
        [styles.headerWithSideMenuCollapsed as string]: isAgentAccount && !!isMenuCollapsed,
      })}
    >
      <div className={styles.headerLeftSide}>
        {activeEnvProfile !== "prod" && (
          <span className={styles[`environment-${activeEnvProfile}`]}>{activeEnvProfile.toUpperCase()}</span>
        )}
      </div>

      {isAgentAccount && <GlobalSearch />}

      <div className={styles.headerRightSide}>
        {isAgentAccount && <NotificationView />}
        {userAccount && <UserMenuView />}
      </div>
    </Layout.Header>
  );
};
